import { Drawer } from 'rsuite';

import './styles.css';

const RDrawer = ({
  backdrop,
  open,
  onClose,
  title,
  actions,
  children,
  ...props
}) => {
  return (
    <Drawer backdrop={backdrop} open={open} onClose={onClose} {...props} className='custom-drawer'>
      {title && (
        <Drawer.Header>
          <Drawer.Title>{title}</Drawer.Title>
          <Drawer.Actions>{actions}</Drawer.Actions>
        </Drawer.Header>
      )}
      <Drawer.Body>{children}</Drawer.Body>
    </Drawer>
  );
};

export default RDrawer;
